import { takeLatest, takeEvery } from "redux-saga/effects";

import { approvalInfoViewAction } from "pages/ApprovalManage/Module/actions/action_type";
import { getApprovalInfoViewData } from "pages/ApprovalManage/Module/sagas/view_sagas";

export function* approvalServiceSaga() {
  yield takeLatest(approvalInfoViewAction, getApprovalInfoViewData);
}
